module.exports = __webpack_public_path__ + "img/fb.4f16a272.svg";